var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 20,
    viewBox: "0 0 32 20",
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#1F72CD",
    height: 19.5,
    rx: 1.75,
    width: 31.5,
    x: 0.25,
    y: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 19.5,
    rx: 1.75,
    stroke: "black",
    strokeWidth: 0.5,
    width: 31.5,
    x: 0.25,
    y: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.69246 6.97665L3.97916 13.0156H7.22736L7.63004 12.0527H8.55049L8.95317 13.0156H12.5286V12.2807L12.8472 13.0156H14.6966L15.0152 12.2651V13.0156H22.451L23.3551 12.0777L24.2017 13.0156L28.0209 13.0233L25.299 10.0129L28.0209 6.97665H24.261L23.3808 7.89718L22.5609 6.97665H14.4717L13.7771 8.53536L13.0662 6.97665H9.82474V7.68653L9.46415 6.97665H6.69246ZM7.32096 7.83422H8.90429L10.7041 11.9292V7.83422H12.4385L13.8286 10.7703L15.1097 7.83422H16.8355V12.1675H15.7854L15.7769 8.77198L14.2459 12.1675H13.3065L11.767 8.77198V12.1675H9.60663L9.19707 11.196H6.98439L6.57568 12.1667H5.41821L7.32096 7.83422ZM22.0664 7.83422H17.7964V12.165H22.0002L23.3552 10.7297L24.6612 12.165H26.0264L24.0421 10.0121L26.0264 7.83422H24.7204L23.3723 9.25303L22.0664 7.83422ZM8.09127 8.5674L7.36228 10.298H8.81941L8.09127 8.5674ZM18.8508 9.52248V8.73143L21.5151 8.73067L22.6777 9.99574L21.4636 11.2677H18.8508V10.4041H21.1802V9.52248H18.8508Z",
    fill: "white",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc1);
export default __webpack_public_path__ + "static/media/ic1.ca55df2545c7bead2028e3ca23bd991a.svg";
export { ForwardRef as ReactComponent };